import React, { forwardRef, MutableRefObject } from 'react';
import { Actionsheet, IActionsheetProps, VStack } from 'native-base';
import { useTheme } from '@springbig/shared';

type ActionSheetWrapperProps = IActionsheetProps & {
    isOpen: boolean;
    onClose?: () => void;
    hideDragIndicator?: boolean;
    children: React.ReactNode;
};

const ActionSheetWrapper = forwardRef(
    ({
        isOpen,
        onClose,
        hideDragIndicator = false,
        children,
        ...props
    }: ActionSheetWrapperProps, ref: MutableRefObject<HTMLDivElement>) => {

        const {
            modal,
            modal_text,
            radius_lg,
        } = useTheme();

        return (
            <Actionsheet
                isOpen={isOpen}
                hideDragIndicator={hideDragIndicator}
                onClose={onClose}
            >
                <Actionsheet.Content
                    zIndex={1}
                    w={'clamp(320px, 100vw, 480px)'}
                    alignSelf={'center'}
                    bg={modal}
                    color={modal_text}
                    roundedTop={radius_lg}
                    p={0}
                    {...props}
                    ref={ref}
                >
                    <VStack
                        w={'100%'}
                        h={'100%'}
                        overflowY={'auto'}
                        p={4}
                    >
                        { children }
                    </VStack>
                </Actionsheet.Content>
            </Actionsheet>
        );
    }
);

ActionSheetWrapper.displayName = 'ActionSheetWrapper';

export default ActionSheetWrapper;
